var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from "styled-components";
import { spacing } from "syf-component-library/defaultTheme";
import { DrawerHeader as DrawerHeaderCL } from "syf-component-library/ui/atoms";
import { colors } from "../../../theme";
export var DrawerHeader = styled(DrawerHeaderCL)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  padding-left: ", "px;\n"], ["\n  padding-left: ", "px;\n"])), spacing.large);
export var HorizontalLine = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  width: 100%;\n  border-top: 0.5px solid ", ";\n"], ["\n  width: 100%;\n  border-top: 0.5px solid ", ";\n"])), colors.lighterGrey);
var templateObject_1, templateObject_2;
